import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/appagent/src/client/components/ui/ClientToaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/var/www/appagent/src/client/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/var/www/appagent/src/client/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/appagent/src/styles/tailwind.css");
